module.exports = __webpack_public_path__ + "static/media/icon_logout.80eeb1b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_logout.svg
// module id = 625
// module chunks = 0